<template>
	<div class="profile">
		<p>COMPANY PROFILE</p>
		<h3>公司简介</h3>
		<div class="container">
			<div class="content clearfix">
				<div v-html="introduce"></div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'profile',
				introduce:''
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.introduceApi,
				})
				.then((res) => {
					this.introduce = res.data.data;
					console.log(this.introduce);
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
		}
	}
</script>

<style lang="less">
@import url("../../../../styles/main.less");
.profile{
	P{
		.margin-top(50);
		.font-size(30);
		color: #00A0FF;
		text-align:center;
	}
	h3{
		.margin-top(10);
		.font-size(30);
		font-weight: 600;
		.margin-bottom(50);
		text-align:center;
	}
	.content{
		.margin-top(20);
		p{
			text-align:left;
			.font-size(30);
			color:#444;
		}
		img{
			width:100% !important;
			height:auto !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Profile.vue